// extracted by mini-css-extract-plugin
export default {"offerItem":"OfferItems_offerItem__C0PmS","offerItem1":"OfferItems_offerItem1__SsQpT","offerItem2":"OfferItems_offerItem2__aDDHD"};